import React, { useState } from 'react';
import { Globe, Activity, ShieldCheck, UserPlus, KeyRound, Film } from 'lucide-react';
import { SessionManagement, SystemHealthMonitor, PilotProgramManagement, StaffAccessManagement, ScrapingMediaManagement } from '../components/features/admin';
import usePageMeta from '../hooks/usePageMeta';

const TABS = [
  { id: 'pilot', label: 'Pilot Program', icon: UserPlus, component: PilotProgramManagement },
  { id: 'staff', label: 'Staff Access', icon: KeyRound, component: StaffAccessManagement },
  { id: 'sessions', label: 'Scraper Sessions', icon: Globe, component: SessionManagement },
  { id: 'media', label: 'Scraping & Media', icon: Film, component: ScrapingMediaManagement },
  { id: 'health', label: 'System Health', icon: Activity, component: SystemHealthMonitor },
];

const GlobalAdminPage = () => {
  // Pilot review is the recurring daily job here - applicants are waiting on a
  // human - so it leads rather than sitting behind infrastructure tabs.
  const [activeTab, setActiveTab] = useState('pilot');

  usePageMeta({ title: 'Global Admin · RepCheck' });

  const Active = (TABS.find((t) => t.id === activeTab) || TABS[0]).component;

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="bg-card shadow-sm border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
            <ShieldCheck className="w-6 h-6 text-brand-600" />
            <h1 className="text-xl sm:text-2xl font-bold text-foreground">Global Admin</h1>
            <span className="px-2 py-1 text-xs font-medium bg-brand-50 text-brand-700 rounded-full dark:bg-brand-500/10 dark:text-brand-200">
              Infrastructure
            </span>
          </div>
          <p className="mt-1 text-sm text-muted-foreground">
            Pilot access, scraper infrastructure and system health. Global administrators only.
          </p>
        </div>
      </div>

      {/* Tab Navigation - scrolls rather than wrapping on narrow screens */}
      <div className="bg-card shadow-sm border-b border-border">
        <div className="max-w-7xl mx-auto">
          <div className="flex gap-6 overflow-x-auto px-4 sm:px-6">
            {TABS.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium transition-colors ${
                    isActive
                      ? 'border-brand-600 text-brand-700'
                      : 'border-transparent text-muted-foreground hover:border-input hover:text-foreground'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto p-4 sm:p-6">
          <Active />
        </div>
      </div>
    </div>
  );
};

export default GlobalAdminPage;
